export default
  process.env.REACT_APP_ENV === 'prod' ? ['https://designstudio.leadscience.com','https://designstudio.dealeron.com'] : 
  process.env.REACT_APP_ENV as any === 'qa' ? ['https://designstudio.dealeronqa.com','https://designstudio.dealeronqa.com'] :
  process.env.REACT_APP_ENV as any === 'uat' ? ['https://designstudio.dealeronuat.com','https://designstudio.dealeronuat.com'] :
  ['http://localhost:3000','http://localhost:3000'];

  //Array of custom domains should have LeadScience at index 0 and DealerOn at index 1